import * as t from "io-ts";
import {FieldMatchCodec} from "./search/search";

export const HeatmapCellCodec = t.intersection([
  t.type({
    latCoord: t.number,
    longCoord: t.number,
    count: t.number,
  }),
  t.partial({}),
]);

export type HeatmapCell = t.TypeOf<typeof HeatmapCellCodec>;

export const HeatmapGridCodec = t.intersection([
  t.type({
    zoom: t.number,
    totalPointCount: t.number,
    totalCellCount: t.number,
    cells: t.array(HeatmapCellCodec),
  }),
  t.partial({}),
]);

export type HeatmapGrid = t.TypeOf<typeof HeatmapGridCodec>;

export const HeatmapBoundsCodec = t.intersection([
  t.type({
    west: t.number,
    south: t.number,
    east: t.number,
    north: t.number,
  }),
  t.partial({}),
]);

export type HeatmapBounds = t.TypeOf<typeof HeatmapBoundsCodec>;

export const HeatmapGridRequestCodec = t.intersection([
  t.type({
    zoom: t.number,
    fromDttm: t.number,
    toDttm: t.number,
    bounds: HeatmapBoundsCodec,
  }),
  t.partial({
    minCountThreshold: t.number,
    person: FieldMatchCodec,
    vehicle: FieldMatchCodec,
    trailer: FieldMatchCodec,
    region: FieldMatchCodec,
  }),
]);

export type HeatmapGridRequest = t.TypeOf<typeof HeatmapGridRequestCodec>;

export const FleetHeatmapGridRequestCodec = t.intersection([
  t.type({
    zoom: t.number,
    fromDttm: t.number,
    toDttm: t.number,
    bounds: HeatmapBoundsCodec,
    capability: t.string,
    regionId: t.string,
  }),
  t.partial({
    minCountThreshold: t.number,
  }),
]);

export type FleetHeatmapGridRequest = t.TypeOf<typeof FleetHeatmapGridRequestCodec>;
